import type { ImpersonateResponse } from '@order-pilot/shared';
import { api } from '@/lib/api';

/**
 * Mints a "view as tenant" session (docs/architecture.md §5.1). Called with the
 * SA client — impersonation is an /admin capability; the token it returns is a
 * tenant one, and the response carries no refresh token by design.
 */
export function impersonateTenant(tenantId: string): Promise<ImpersonateResponse> {
  return api.post<ImpersonateResponse>(
    `/admin/tenants/${encodeURIComponent(tenantId)}/impersonate`,
  );
}
